import { createContext } from 'react';

export const DeletePayoutProfileModalContext = createContext(null);
